import React from "react";
import {moment} from "../../../../services/moment-extensions";

export const Reminders = ({reminders}) => {
    return (
        <div className="sl-flex sl-flex-col sl-gap-1-point-5 sl-p-3">
            <div className="sl-font sl-font-semibold sl-text-sm sl-text-gray-900 sl-text-left">Reminders sent</div>
            <div className="sl-font sl-font-normal sl-text-xs sl-text-gray-700 sl-text-left">
                Three reminders will be sent automatically before a request is marked as "Failed".
            </div>

            {reminders && <div className="sl-flex sl-flex-col sl-gap-3">
                {reminders.map((reminder, index) => (
                    <div key={index} className="sl-flex sl-gap-3">
                        <div className="sl-flex sl-align-center sl-justify-center sl-flex sl-flex-col sl-gap-1">
                            <div
                                className="sl-rounded-full sl-h-8 sl-p-1-point-5 sl-bg-gray-200 sl-text-gray-700">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none">
                                    <path
                                        d="M7.79535 17.5C8.38297 18.0186 9.15484 18.3333 10.0002 18.3333C10.8456 18.3333 11.6175 18.0186 12.2051 17.5M1.91178 4.84987C1.89983 3.64041 2.5519 2.511 3.60529 1.91662M18.0853 4.84987C18.0973 3.64042 17.4452 2.511 16.3918 1.91663M15.0002 6.66663C15.0002 5.34054 14.4734 4.06877 13.5357 3.13109C12.5981 2.19341 11.3263 1.66663 10.0002 1.66663C8.67413 1.66663 7.40236 2.19341 6.46467 3.13109C5.52699 4.06877 5.00021 5.34054 5.00021 6.66663C5.00021 9.24178 4.3506 11.0049 3.62493 12.1711C3.01281 13.1549 2.70676 13.6467 2.71798 13.7839C2.7304 13.9359 2.76259 13.9938 2.88502 14.0846C2.99559 14.1666 3.49403 14.1666 4.49092 14.1666H15.5095C16.5064 14.1666 17.0048 14.1666 17.1154 14.0846C17.2378 13.9938 17.27 13.9359 17.2824 13.7839C17.2937 13.6467 16.9876 13.1549 16.3755 12.1711C15.6498 11.0049 15.0002 9.24178 15.0002 6.66663Z"
                                        stroke="#475467" stroke-width="1.67" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                            </div>
                            {index !== reminders.length - 1 && (
                                <div className="sl-w-1">
                                    <div className="sl-w-2-out-4 sl-rounded-lg sl-bg-gray-200 sl-h-4"/>
                                </div>)}
                        </div>
                        <div className="sl-flex sl-align-flex-start sl-justify-center sl-gap-2 sl-pt-6px">
                            <div className="sl-text-sm sl-font-medium sl-text-gray-700">
                                {moment(reminder.created_at).toMediumDate()}
                            </div>
                            <div className="sl-text-sm sl-font-normal sl-text-gray-base">
                                {moment(reminder.created_at).toShortTime()}
                            </div>
                        </div>
                    </div>
                ))}
            </div>}
        </div>
    )
}
